import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import RimFilter from 'components/filters/RimFilter/RimFilter'
import {
	setFilter,
	selectResult,
	selectCriteria,
	selectFilterState
} from '../carRimSearchSlice'

const RimSearchFilter = () => {
	const dispatch = useDispatch()
	const result = useSelector(selectResult)
	const usedCriteria = useSelector(selectCriteria)
	const filterState = useSelector(selectFilterState)

	const handleFilterChange = (articleIds, filterState) => {
		dispatch(setFilter({ articleIds, filterState }))
	}

	const emptySearchResult = result &&
		(result.inStock.length || result.incoming.length || result.toOrder.length) ? false : true

	return (
		<div className="RimSearchFilter">
			{
				!emptySearchResult &&
				<RimFilter
					result={result}
					onFilterChange={handleFilterChange}
					filterState={filterState}
					showRimType={true}
					criteria={usedCriteria} />
			}
		</div>
	)
}

export default RimSearchFilter
